import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { bookingApi } from "functions/apis";
import { token } from "functions/Helper";

const useStyles = makeStyles(styles);

export function EditRouteBookingConfiguration(props) {
  const classes = useStyles();

  const editRouteBookingConfigurationSignal = React.useRef(
    new AbortController()
  );
  const { id } = useParams();

  const [route, setRoute] = useState(null);
  const [payload, setPayload] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    return () => editRouteBookingConfigurationSignal.current.abort();
  }, []);

  useEffect(() => {
    if (token["booking.routes.read"] === "allowed" || token.is_admin === "True")
      bookingApi
        .get("/Routes/" + id, {
          signal: editRouteBookingConfigurationSignal.current.signal
        })
        .then(data => {
          setRoute(data);
          setPayload({
            terminalFeeLookUpCode: data.terminalFeeLookUpCode,
            pdfLookUpCode: data.pdfLookUpCode
          });
        })
        .catch(error => console.log(error));
  }, [id]);

  const handleTerminalFeeLookUpCodeChanged = e =>
    setPayload({
      ...payload,
      terminalFeeLookUpCode: e.target.value === "" ? null : e.target.value
    });

  const handlePDFLookUpCodeChanged = e =>
    setPayload({
      ...payload,
      pdfLookUpCode: e.target.value === "" ? null : e.target.value
    });

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);

    bookingApi
      .put("/Routes/" + id, payload, {
        signal: editRouteBookingConfigurationSignal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/Route/Detail/" + id} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              EDIT BOOKING CONFIGURATION
            </h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            {payload !== null && (
              <form onSubmit={handleSubmit}>
                <GridContainer>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Code"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: route?.code ?? "",
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6}>
                    <CustomInput
                      labelText="Name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        value: route?.name ?? "",
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      labelText="Terminal Fee Look Up Code"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: handleTerminalFeeLookUpCodeChanged,
                        value: payload.terminalFeeLookUpCode ?? "",
                        inputProps: { maxLength: 50 }
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <CustomInput
                      labelText="PDF Look Up Code"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: handlePDFLookUpCodeChanged,
                        value: payload.pdfLookUpCode ?? "",
                        inputProps: { maxLength: 50 }
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} md={12}>
                    <Button
                      disabled={disabled}
                      color="rose"
                      type="submit"
                      value="Submit"
                    >
                      Submit
                    </Button>
                  </GridItem>
                </GridContainer>
              </form>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

EditRouteBookingConfiguration.propTypes = {
  history: PropTypes.object
};
